import React from 'react';
import { ComponentProps } from './Tab.types';
import StyledTab from './Tab.styled';

const Tab: React.FC<ComponentProps> = ({ label, onTabChange, isActive, isDisabled }) => {
  return (
    <StyledTab onClick={onTabChange} pb={3} state={isActive ? 'active' : 'normal'} disabled={isDisabled}>
      {label}
    </StyledTab>
  );
};

export default Tab;
